export const INVOICE_REQUEST_STATUS = {
  PENDING: "pending",
  SUCCESS: "success",
  ERROR: "error"
};
